// src/pages/AdminPage/components/ConfirmModal.tsx
import { AlertTriangle } from "lucide-react";

interface ConfirmModalProps {
  open: boolean;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function ConfirmModal({
  open,
  title = "O'chirishni tasdiqlang",
  message = "Bu amalni qaytarib bo'lmaydi!",
  confirmText = "O'chirish",
  cancelText = "Bekor",
  onConfirm,
  onCancel,
}: ConfirmModalProps) {
  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 200,
        padding: 16,
      }}
      onClick={onCancel}>
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "#111827",
          border: "1px solid rgba(239,68,68,.3)",
          borderRadius: 20,
          padding: 24,
          width: "100%",
          maxWidth: 360,
          textAlign: "center",
        }}>
        <div
          style={{
            width: 52,
            height: 52,
            borderRadius: "50%",
            background: "rgba(239,68,68,.1)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 16px",
          }}>
          <AlertTriangle size={24} color="#EF4444" />
        </div>
        <h3
          style={{
            color: "#fff",
            fontWeight: 800,
            fontSize: 16,
            marginBottom: 8,
          }}>
          {title}
        </h3>
        <p style={{ color: "#64748B", fontSize: 13, marginBottom: 24 }}>
          {message}
        </p>
        <div style={{ display: "flex", gap: 10 }}>
          <button
            onClick={onCancel}
            style={{
              flex: 1,
              padding: "11px",
              borderRadius: 12,
              border: "1px solid #1E2D45",
              background: "transparent",
              color: "#E2E8F0",
              fontWeight: 700,
              cursor: "pointer",
            }}>
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            style={{
              flex: 1,
              padding: "11px",
              borderRadius: 12,
              border: "none",
              background: "#EF4444",
              color: "#fff",
              fontWeight: 700,
              cursor: "pointer",
            }}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
